import { URL_API } from 'react-native-dotenv'

import axios, { AxiosResponse } from 'axios'
import { IAccountInfo } from '../IAccountInfo'
import { accountInfoTransformer } from './transformer'

export const getAccountInfo = (
  establishmentId: string,
  authToken: string
): Promise<IAccountInfo> => {
  const requestOptions: object = {
    method: 'GET',
    url: `${URL_API}/anonymous/customers/token/${authToken}?establishment_id=${establishmentId}`,
  }
  return axios(requestOptions).then(
    (response): IAccountInfo => accountInfoTransformer(response.data.data)
  )
}

type ApiErrDto = {
  message_template?: string;
  message?: string;
};

type DeleteAccountResult =
  | 'success'
  | { code: 'FUTURE_APPOINTMENTS' }
  | { code: 'UNKNOWN_ERROR'; message?: string };

export const deleteAccountInfo = (
  establishmentId: string,
  authToken: string
): Promise<DeleteAccountResult> => {
  const requestOptions = {
    method: 'DELETE' as const,
    url: `${URL_API}/anonymous/customers/token/${authToken}?establishment_id=${establishmentId}`,
  };

  return axios(requestOptions)
    .then(
      (response: AxiosResponse<{ status: 'success' | unknown }>) =>
        response.data.status === 'success' ? 'success' : ({ code: 'UNKNOWN_ERROR' } as const)
    )
    .catch((err) => {
      const apiErr: ApiErrDto[] =
        (err && err.response && err.response.data && err.response.data.errors && err.response.data.errors.uuid) ||
        {};

      const msg = apiErr[0].message_template;

      if (typeof msg === 'string' && /future appointments/i.test(msg)) {
        return { code: 'FUTURE_APPOINTMENTS' } as const;
      }

      return { code: 'UNKNOWN_ERROR', message: msg } as const;
    });
};
